import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'selfEvaluation'
const initialState = {
  list: null,
  loading: false,
  error: null,
}


export const search = createApiAction('selfEvaluation/search', client.search('/api/evaluation/admin/self/rating'))
export const get = createApiAction('selfEvaluation/get', client.retrieve('/api/evaluation/admin/self/rating/:id'))
export const save = createApiAction('selfEvaluation/save', client.save('/api/evaluation/admin/self/rating'))
export const destroy = createApiAction('selfEvaluation/delete', client.destroy('/api/evaluation/admin/self/rating/:id'))

const update = (state, action) => {
  const rating = action.payload;
  const { standardId, id: ratingId } = rating;

  const updatedList = state.list.map(item => {
    if (item.id === standardId) {
      const updatedRatings = item.adminEvaluationRatings.map(r =>
        r.id === ratingId ? rating : r
      );

      const isRatingPresent = item.adminEvaluationRatings.some(r => r.id === ratingId);
      return {
        ...item,
        adminEvaluationRatings: isRatingPresent
          ? updatedRatings
          : [...item.adminEvaluationRatings, rating],
      };
    }
    return item;
  });

  const isBucketPresent = state.list.some(item => item.id === standardId);
  state.list = isBucketPresent
    ? updatedList
    : [...state.list, { id: standardId, adminEvaluationRatings: [rating] }];
};

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearSelfEvaluation: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      }
      )
  },
})

export const { clearSelfEvaluation } = sessionSlice.actions
export default sessionSlice.reducer
